export default "__VITE_ASSET__D61h8z6b__"